var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useMemo } from 'react';
import { Route, Routes, useParams, useSearchParams } from 'react-router-dom';
import ListOfBoats from './ListOfBoats';
import BookingDetails from './BookingDetails';
import { publicSearchBoats } from '@api';
import { useColorScheme } from '@mui/material';
// Prevent Intercom from loading
if (window.Intercom) {
    window.Intercom('shutdown');
}
export default function BookingPage({ pass }) {
    const [boatsData, setBoatsData] = useState(null);
    // Retrieve customerId from URL, fallback to `pass`
    const { customerId: paramCustomerId } = useParams();
    const customerId = paramCustomerId || (pass === null || pass === void 0 ? void 0 : pass.customerId) || '';
    const [searchParams] = useSearchParams();
    const locationId = searchParams.get('locationId') || (pass === null || pass === void 0 ? void 0 : pass.locationId) || '';
    const primaryColor = searchParams.get('primaryColor') || (pass === null || pass === void 0 ? void 0 : pass.primaryColor) || '#1976D2';
    const backgroundColor = searchParams.get('backgroundColor') || (pass === null || pass === void 0 ? void 0 : pass.backgroundColor) || '#FFFFFF';
    const secondaryColor = searchParams.get('secondaryColor') || (pass === null || pass === void 0 ? void 0 : pass.secondaryColor) || '#4a4a4a';
    // Force MUI into light mode
    const { setMode } = useColorScheme();
    useEffect(() => {
        const fetchBoatsData = () => __awaiter(this, void 0, void 0, function* () {
            setMode('light');
            if (!customerId)
                return;
            // Fetch boat data
            const fetchedBoatsData = yield publicSearchBoats(customerId);
            // Optionally filter by location
            const filteredBoatsData = locationId
                ? fetchedBoatsData.filter((boat) => boat.LocationID === locationId)
                : fetchedBoatsData;
            setBoatsData(filteredBoatsData);
        });
        fetchBoatsData();
    }, [customerId, locationId, setMode]);
    // Dynamically set CSS variables for brand colors
    useEffect(() => {
        document.documentElement.style.setProperty('--actionColor', primaryColor);
        document.documentElement.style.setProperty('--primaryBgColor', backgroundColor);
        document.documentElement.style.setProperty('--primaryFgColor', primaryColor);
        document.documentElement.style.setProperty('--secondaryFgColor', secondaryColor);
        document.documentElement.style.setProperty('--background-color', backgroundColor);
        document.body.style.backgroundColor = backgroundColor;
        document.body.style.color = primaryColor;
    }, [primaryColor, backgroundColor, secondaryColor]);
    const boats = useMemo(() => boatsData !== null && boatsData !== void 0 ? boatsData : [], [boatsData]);
    const initialBoat = useMemo(() => boats.find((b) => b.BoatID === (pass === null || pass === void 0 ? void 0 : pass.initialBoatId)), [boats, pass === null || pass === void 0 ? void 0 : pass.initialBoatId]);
    const initialBoats = useMemo(() => initialBoat ? [initialBoat] : undefined, [initialBoat]);
    // If a specific BoatID was passed in for direct detail view
    if ((pass === null || pass === void 0 ? void 0 : pass.initialBoatId) && initialBoats) {
        return _jsx(BookingDetails, { boats: initialBoats });
    }
    return (_jsx("div", { className: "booking-page-container", children: _jsxs(Routes, { children: [_jsx(Route, { path: "boat/:boatId", element: _jsx(BookingDetails, { boats: boats }) }), _jsx(Route, { path: "*", element: _jsx(ListOfBoats, { boats: boats, customerId: customerId }) })] }) }));
}
